import * as posthogModule from 'posthog-js';

import { AnalyticsPlugin, TrackProperties } from './analytics-plugin.types';

const posthogHost = 'https://us.i.posthog.com';
const posthogToken = 'phc_DD17zeRMbnXxATfwADiVqfgOPfjCS3F6dW5UuXhMlig';

export class PostHogAnalytics implements AnalyticsPlugin {
  posthog: posthogModule.PostHog | undefined;

  async init() {
    if (!this.posthog && typeof window !== 'undefined') {
      this.posthog = posthogModule.default;
      this.posthog?.init(posthogToken, {
        api_host: posthogHost,
        autocapture: false,
        opt_in_site_apps: true,
      });
    }
  }

  constructor() {
    this.init();
  }

  async getCurrentSessionId(): Promise<string | undefined> {
    return this.posthog?.get_session_id();
  }

  async track(eventName: string, properties?: TrackProperties) {
    this.posthog?.capture(eventName, properties);
  }

  alias(orderId: string) {
    this.posthog?.alias(orderId);
  }

  async identify(userId: string, userProperties?: TrackProperties) {
    this.posthog?.identify(userId, userProperties || {});
  }

  async trackCharge(amount: number, properties?: TrackProperties): Promise<void> {
    this.posthog?.capture('$transaction', {
      $amount: amount,
      ...properties,
    });
  }

  reset() {
    this.posthog?.reset();
  }
}
